import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "list-group mb-3 requirements" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-10" }
const _hoisted_6 = {
  key: 0,
  class: "col-2"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 1,
  class: "col-2 fs-5"
}
const _hoisted_9 = {
  key: 2,
  class: "col-md-12 px-4 mt-2"
}
const _hoisted_10 = { class: "text-primary me-1" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "alert alert-danger" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_16 = {
  key: 1,
  class: "text-center text-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BIconCheckLg = _resolveComponent("BIconCheckLg")!
  const _component_BIconXLg = _resolveComponent("BIconXLg")!
  const _component_BIconInfoCircle = _resolveComponent("BIconInfoCircle")!
  const _component_BIconExclamationTriangle = _resolveComponent("BIconExclamationTriangle")!
  const _component_BIconArrowClockwise = _resolveComponent("BIconArrowClockwise")!
  const _component_BIconArrowRight = _resolveComponent("BIconArrowRight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", {
      innerHTML: _ctx.$t('welcome'),
      class: "text-center"
    }, null, 8, _hoisted_1),
    (!_ctx.data.compatible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.requirements, (requirementStatus, requirement) => {
              return (_openBlock(), _createElementBlock("div", {
                key: requirement,
                class: "list-group-item"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.translateRequirement(requirement)), 1),
                  (requirement === 'php')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["float-end", requirementStatus ? 'text-success' : 'text-danger']),
                          title: _ctx.data.phpFullVersion
                        }, _toDisplayString(_ctx.data.phpVersion), 11, _hoisted_7)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("span", {
                          class: _normalizeClass([requirementStatus ? 'text-success' : 'text-danger', "float-end"])
                        }, [
                          requirementStatus
                            ? (_openBlock(), _createBlock(_component_BIconCheckLg, { key: 0 }))
                            : _createCommentVNode("", true),
                          (!requirementStatus)
                            ? (_openBlock(), _createBlock(_component_BIconXLg, { key: 1 }))
                            : _createCommentVNode("", true)
                        ], 2)
                      ])),
                  (!requirementStatus && requirement !== 'php')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, [
                          _createVNode(_component_BIconInfoCircle)
                        ]),
                        _createElementVNode("span", {
                          innerHTML: _ctx.translateRequirementHelp(requirement)
                        }, null, 8, _hoisted_11)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_BIconExclamationTriangle),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('requirements.missing')), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshRequirements && _ctx.refreshRequirements(...args))),
              disabled: _ctx.loading,
              class: "btn btn-secondary mx-1"
            }, [
              _createVNode(_component_BIconArrowClockwise),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('requirements.recheck')) + " ", 1),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                : _createCommentVNode("", true)
            ], 8, _hoisted_14)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('requirements.success')), 1),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args))),
            class: "btn btn-primary rounded-pill mx-1"
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('continue')) + " ", 1),
            _createVNode(_component_BIconArrowRight)
          ])
        ]))
  ]))
}